var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sw__main-image-content-container",
      style: _vm.paddingStyles
    },
    [
      _c(
        "section",
        {
          staticClass: "sw",
          class: [
            _vm.imageWidthClass,
            _vm.backgroundColorClass,
            _vm.reversedClass
          ]
        },
        [
          _c("div", { staticClass: "sw__image" }, [_vm._t("image")], 2),
          _c(
            "article",
            {
              staticClass: "sw__main",
              class: [_vm.textAlignmentClass, _vm.backgroundColorClass]
            },
            [
              _c(
                "div",
                { staticClass: "sw__main-wrap" },
                [_vm._t("content")],
                2
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }